import AcceptInvitation from './AcceptInvitation';

const routes = [
	{
		name: 'acceptInvitation',
		path: '/invitation/:token',
		component: AcceptInvitation
	}
];

export default routes;